module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-content edi-login",
    attrs: {
      "id": "loginForm"
    }
  }, [_c('div', {
    staticClass: "login-page__top"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-page__content"
  }, [_c('form', {
    staticClass: "page-content__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "logo-board"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.store.sysInfo && ((_vm.store.sysInfo.logo) + "?1") || ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-title fx-festival-color",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.store.sysInfo && _vm.store.sysInfo.name || '风行供货商EDI'))])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview ui-listview-inset fieldset-1"
  }, [_c('li', {
    staticClass: "ui-listview-first-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "ui-align-center",
    attrs: {
      "type": "text",
      "placeholder": "账号/手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-last-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ui-align-center",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup fieldset-2"
  }, [_c('input', {
    staticClass: "submit fx-festival-btn-color",
    class: {
      'ui-disable': _vm.submitDisable
    },
    attrs: {
      "type": "submit",
      "value": "登录"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "login-page__bottom"
  }, [_c('router-link', {
    staticClass: "footer-left",
    attrs: {
      "to": "/forgot"
    }
  }, [_vm._v("忘记密码?")]), _vm._v(" "), (_vm.store.sysInfo && (!_vm.store.sysInfo.showRegister || _vm.store.sysInfo.showRegister === '1')) ? _c('router-link', {
    staticClass: "footer-right",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("新用户注册")]) : _vm._e()], 1), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-319f9e24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 554
// module chunks = 1